module.exports = __webpack_public_path__ + "static/img/4liudiao.c5a722a9.png";